var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main"},[_c('div',{style:({
        width: _vm.height + 'px',
        minWidth: _vm.height + 'px',
        height: _vm.height + 'px',
        margin: '0 auto',
      }),attrs:{"id":_vm.id}})])])}
var staticRenderFns = []

export { render, staticRenderFns }